var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      directives: [{ name: "tooltip", rawName: "v-tooltip" }],
      ref: "inputUnit",
      staticClass: "input-unit file-input",
      attrs: { "data-toggle": "tooltip", title: _vm.selectedFiles }
    },
    [
      _c("label", { attrs: { for: _vm.formFieldId } }, [
        _vm._v("\n        " + _vm._s(_vm.label)),
        _vm.isRequired
          ? _c("span", { staticStyle: { "font-size": ".8rem" } }, [_vm._v("*")])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "input-unit-preview",
          class: { disabled: !!_vm.selectedFiles },
          attrs: { "data-testing": "form-attachment-file-name" }
        },
        [_vm._v("\n        " + _vm._s(_vm.selectedFiles) + "\n    ")]
      ),
      _vm._v(" "),
      !_vm.selectedFiles
        ? _c("span", { staticClass: "input-unit-btn" }, [
            _c("i", { staticClass: "fa fa-ellipsis-h" })
          ])
        : _c(
            "span",
            {
              staticClass: "input-unit-btn",
              attrs: { "data-testing": "remove-attached-file" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.clearSelectedFiles()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        attrs: {
          type: "file",
          multiple: _vm.allowMultiple,
          name: _vm.formFieldId,
          id: _vm.formFieldId,
          disabled:
            _vm.allowedFileExtensions.trim().length === 0 ||
            !!_vm.selectedFiles,
          accept: _vm.allowedFileExtensions,
          "data-testing": "form-attachment-input"
        },
        on: { change: _vm.collectFiles }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }